module.exports = __webpack_public_path__ + "assets/be01b269928502511a59b1f166e6c193.svg";